import { render, staticRenderFns } from "./dashboard-insight.vue?vue&type=template&id=7f754476&scoped=true&"
import script from "./dashboard-insight.vue?vue&type=script&lang=js&"
export * from "./dashboard-insight.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-insight.vue?vue&type=style&index=0&id=7f754476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f754476",
  null
  
)

/* custom blocks */
import block0 from "./dashboard-insight.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports